module.exports = __webpack_public_path__ + "static/img/registration_flow_image_02.013fa6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/members-registration-flow/registration_flow_image_02.jpg
// module id = 81RS
// module chunks = 6